import './Loading.css'

export default function Loading() {
  return <img alt="" src="/loading.png" />
}
